module.exports = __webpack_public_path__ + "img/Woman_Presentation_Halfbody (2).951858c.png";